export const metadata = {
    currentPage: 1,
    nextPage: null,
    prevPage: null,
    totalPages: 1,
    totalCount: 0,
};

export const evaluation = [
    {value: 0, name: "Apto", badge: "success"},
    {value: 1, name: "Apto con observaciones",badge: "warning"},
    {value: 2, name: "No apto", badge: "error"},
]

export const GENDER_VALUES = [
    {
        value: 0,
        name: "Femenino",
    },

    {
        value: 1,
        name: "Masculino",
    },
    {
        value: 2,
        name: "Prefiero no decirlo",
    },
    {
        value: 3,
        name: "Personalizado",
    },
]

export const OPTIONAL_VALUES = [
    {
        value: 0,
        name: "Ocultar opción",
    },

    {
        value: 1,
        name: "Mostrar y opcional",
    },
    {
        value: 2,
        name: "Mostrar y obligatoria",
    },
]

export const APPLICANTS_ACTIONS = ["COPY", "MOVE", "DELETE", "REQUEST", "SHOW_REQUEST"]

export const SELECTION_PROCESSES_STATUSES = {
  5: "ACTIVO",
  6: "SUSPENDIDO",
  7: "CERRADO",
  8: "PENDIENTE"
}

export const SELECTION_PROCESSES_STATUSES_ARRAY = [
    {
        "value": 5,
        "label": "Activos",
        "created_at": "2019-01-23T20:51:51.586Z",
        "name_en": "active"
    },
    {
        "value": 6,
        "label": "Suspendidos",
        "created_at": "2019-01-23T20:51:51.590Z",
        "name_en": "suspended"
    },
    {
        "value": 7,
        "label": "Cerrados",
        "created_at": "2019-01-23T20:51:51.593Z",
        "name_en": "closed"
    },
    {
        "value": 8,
        "label": "Pendientes",
        "created_at": "2021-08-23T23:21:13.926Z",
        "name_en": "draft"
    }
]

export const STEPS = [
  { title: "Anuncio" },
  { title: "Formulario de postulación" },
  { title: "Datos generales" },
  { title: "Publicar" },
];

export const CIVIL_STATUS_VALUES = {
    single: "Soltero",
    married: "Casado",
    divorced: "Divorciado",
    widowed: "Viudo",
    cohabitant: "Cohabitante",
    civil_union: "Unión civil",
}